<!--  -->
<template>
  <div class="order">
    <multi :loginOn="loginOn"></multi>
    <div class="main">
      <div class="content" v-show="submitShow">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="选择语言" prop="language">
            <el-select
              v-model="ruleForm.languageSource"
              placeholder="请选择"
              size="small"
              style="width:150px"
              @change="selectLanguageS"
            >
              <el-option
                v-for="item in options1"
                :key="item.ye_id"
                :label="item.ye_name"
                :value="item.ye_id"
              ></el-option>
            </el-select>
            <i class="exchange" @click="exchange"></i>
            <el-select
              v-model="ruleForm.languageTarget"
              placeholder="请选择"
              size="small"
              style="width:150px"
              @change="selectLanguageT"
            >
              <el-option
                v-for="item in options2"
                :key="item.ye_id"
                :label="item.ye_name"
                :value="item.ye_id"
              ></el-option>
            </el-select>
            <span style="margin-left:10px;color:#999;font-size:14px;">目前只支持中文和其他语言互译</span>
          </el-form-item>
          <el-form-item label="翻译需求" prop="region">
            <el-radio v-model="radio" label="1" border :disabled="bzjy">
              标准级
              <p class="jg" v-if="priceSet.standard != 0">
                ￥
                <span>{{priceSet.standard}}</span>
                /千{{word?'字':'词'}}
              </p>
              <p v-else class="no">暂不支持</p>
              <p class="txt">适合非紧急的日常沟通、资料阅读等内容</p>
              <el-divider></el-divider>
              <ul class="explain">
                <li>
                  <img src="../../assets/sd.png" alt />译员精心翻译+质检
                </li>
                <li>
                  <img src="../../assets/sd.png" alt />译员具备3年以内翻译经验
                </li>
                <li>
                  <img src="../../assets/sd.png" alt />累计翻译字数100万+
                </li>
              </ul>
            </el-radio>
            <el-radio v-model="radio" label="2" border :disabled="yyjy">
              应用级
              <p class="jg" v-if="priceSet.application != 0">
                ￥
                <span>{{priceSet.application}}</span>
                /千{{word?'字':'词'}}
              </p>
              <p v-else class="no">暂不支持</p>
              <p class="txt">适合较为专业的内容内部文档、商务交流等</p>
              <el-divider></el-divider>
              <ul class="explain">
                <li>
                  <img src="../../assets/sd.png" alt />资深译员翻译+审校+质检
                </li>
                <li>
                  <img src="../../assets/sd.png" alt />译员具备3-5年翻译经验
                </li>
                <li>
                  <img src="../../assets/sd.png" alt />累计翻译字数200万+
                </li>
              </ul>
            </el-radio>
            <el-radio v-model="radio" label="3" border :disabled="myjy">
              母语级
              <p class="jg" v-if="priceSet.native_language != 0">
                ￥
                <span>{{priceSet.native_language}}</span>
                /千{{word?'字':'词'}}
              </p>
              <p v-else class="no">暂不支持</p>
              <p class="txt" style="width:180px">适合地道性要求高的内容,演讲稿、涉外信函、出海产品介绍等</p>
              <el-divider></el-divider>
              <ul class="explain">
                <li>
                  <img src="../../assets/sd.png" alt />资深译员翻译+审校+母语审校+质检
                </li>
                <li>
                  <img src="../../assets/sd.png" alt />译员具备3-5年翻译经验
                </li>
                <li>
                  <img src="../../assets/sd.png" alt />累计翻译字数300万+
                </li>
              </ul>
            </el-radio>
            <el-radio v-model="radio" label="4" border :disabled="zjjy">
              专业级
              <p class="jg" v-if="priceSet.expert != 0">
                ￥
                <span>{{priceSet.expert}}</span>
                /千{{word?'字':'词'}}
              </p>
              <p v-else class="no">暂不支持</p>
              <p class="txt" style="width:180px">适合严谨性要求高的内容,书籍出版、论文发表、政务稿件等</p>
              <el-divider></el-divider>
              <ul class="explain">
                <li>
                  <img src="../../assets/sd.png" alt />专业级译员翻译+审校+母语审校+审校+定稿质检
                </li>
                <li>
                  <img src="../../assets/sd.png" alt />译员具备5年以上翻译经验
                </li>
                <li>
                  <img src="../../assets/sd.png" alt />累计翻译字数500万+
                </li>
              </ul>
            </el-radio>
            <p style="color:#666;font-size:14px;">
              <i class="el-icon-warning-outline"></i> 以300字（中文字符数/非中文单词数）为基础起计价，不足300字按照300字收取
            </p>
          </el-form-item>
          <el-form-item label="翻译内容" prop="contentTxt" v-show="doc">
            <div class="remarks">
              或
              <button type="button" @click="todoc">点击这里上传</button>
              支持：txt、rar、zip、doc、docx、pdf、jpg… ，20M以内，多文件请压缩打包上传
            </div>
            <el-input
              type="textarea"
              placeholder
              v-model="ruleForm.contentTxt"
              style="width:750px"
              :rows="9"
              resize="none"
            ></el-input>
          </el-form-item>
          <el-form-item label="翻译内容" prop="contentFile" v-show="!doc">
            <el-upload
              class="upload-demo"
              :action="upload"
              multiple
              :limit="1"
              :on-exceed="handleExceed"
              :file-list="ruleForm.contentFile"
              :before-upload="beforeUpload"
              accept=".rar, .zip, .doc, .docx, .pdf, .jpg, .txt"
              :on-success="uploadSuccess"
              :on-remove="removeFile"
            >
              <button
                type="button"
                style="width:130px;margin-right:10px;margin-left:10px;"
                :disabled="uploadStatus"
                :class="uploadStatus?'submitActive':''"
              >点击上传</button>
            </el-upload>
            <div class="todoc">
              或
              <button
                type="button"
                style="width:130px;margin-right:10px;margin-left:10px;"
                @click="todoc"
              >输入文本</button>
              <div
                slot="tip"
                style="display:inline-block;font-size:13px;color:#999;"
              >支持扩展名：rar、zip、doc、docx、pdf、jpg，20M以内，多文件请压缩打包上传</div>
            </div>
          </el-form-item>
          <el-form-item label="需求备注" prop="remarks">
            <el-input
              type="textarea"
              placeholder="可考虑提供的说明信息：1、参考资料：如网站链接、截图或其他文档  2、使用场合：如将用于给重要的客户做演讲..."
              v-model="ruleForm.remarks"
              style="width:750px"
              :rows="2"
              resize="none"
              maxlength="60"
              @keydown.native="listen($event)"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="phone">
            <el-input
              v-model="ruleForm.phone"
              placeholder="请输入联系电话"
              maxlength="11"
              size="small"
              style="width:300px"
            ></el-input>
            <el-checkbox v-model="ruleForm.checkedPhone">免费获取短信随时提醒订单状态</el-checkbox>
          </el-form-item>
          <el-form-item label="联系邮箱" prop="email">
            <el-input
              v-model="ruleForm.email"
              placeholder="请填写您的邮箱地址"
              size="small"
              style="width:300px"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="confirmInfo">
          <h4>订单信息确认</h4>
          <el-divider></el-divider>
          <div class="info">
            <span>订单信息</span>
            <ul>
              <li>
                语项：
                <span>{{orderInfo.source}}->{{orderInfo.target}}</span>
              </li>
              <li>
                预计返稿时间:
                <span>待评估</span>
                <i class="el-icon-question" style="margin-left:10px;" @click="timeshow = true"></i>
              </li>
            </ul>
          </div>
          <el-divider></el-divider>
          <el-checkbox v-model="checkedRule">
            我已阅读并同意
            <a
              class="rule"
              href="http://www.qxchuhai.com/publicPage?numbercms=102629"
              target="_blank"
            >《人工翻译服务条款》</a>
          </el-checkbox>
          <button
            class="submit"
            :class="!checkedRule?'submitActive':''"
            @click="submitOrder()"
            :disabled="!checkedRule"
            v-loading.fullscreen.lock="fullscreenLoading"
          >提交订单</button>
          <i
            class="el-icon-question"
            style="color:#666;font-size:12px;margin-left:10px;"
          >翻译完成后请在“我的翻译”中查看翻译结果</i>
        </div>
      </div>
      <div class="submitbox" v-show="!submitShow"></div>
    </div>
    <login :visible.sync="dialogFormVisible" @result="result"></login>
    <div id="overlay-bg" v-show="timeshow">
      <div class="message-box overlay-box-common" style="width: 970px; height: 500px;">
        <header>
          <span id="title">返稿时间估算</span>
          <a class="close-message-box" @click="timeshow=false">
            <i class="el-icon-close"></i>
          </a>
        </header>
        <div id="message-area">
          <div class="trans-time-container">
            <table class="trans-time-table">
              <tbody>
                <tr>
                  <td colspan="3">译员正常处理速度</td>
                  <td colspan="3">不足一天工作量时间速度预估</td>
                </tr>
                <tr>
                  <th>语言方向</th>
                  <th>级别</th>
                  <th>正常处理速度</th>
                  <th>语言方向</th>
                  <th>级别</th>
                  <th>速度</th>
                </tr>
                <tr>
                  <td rowspan="4">中译英</td>
                  <td>标准级</td>
                  <td>3000字/天</td>
                  <td rowspan="4">中译英</td>
                  <td>标准级</td>
                  <td>300字/小时</td>
                </tr>
                <tr>
                  <td>应用级</td>
                  <td>2500字/天</td>
                  <td>应用级</td>
                  <td>250字/小时</td>
                </tr>
                <tr>
                  <td>母语级</td>
                  <td>1500字/天</td>
                  <td>母语级</td>
                  <td>200字/小时</td>
                </tr>
                <tr>
                  <td>专业级</td>
                  <td>1000字/天</td>
                  <td>专业级</td>
                  <td>130字/小时</td>
                </tr>
                <tr>
                  <td rowspan="4">英译中</td>
                  <td>标准级</td>
                  <td>1500词/天</td>
                  <td rowspan="4">英译中</td>
                  <td>标准级</td>
                  <td>150词/小时</td>
                </tr>
                <tr>
                  <td>应用级</td>
                  <td>1250词/天</td>
                  <td>应用级</td>
                  <td>130词/小时</td>
                </tr>
                <tr>
                  <td>母语级</td>
                  <td>750词/天</td>
                  <td>母语级</td>
                  <td>100词/小时</td>
                </tr>
                <tr>
                  <td>专业级</td>
                  <td>500词/天</td>
                  <td>专业级</td>
                  <td>60词/小时</td>
                </tr>
                <tr>
                  <td>中译外（其他16语种）</td>
                  <td>应用级</td>
                  <td>1500字/天</td>
                  <td>中译外（其他16语种）</td>
                  <td>应用级</td>
                  <td>200字/小时</td>
                </tr>
                <tr>
                  <td>外译中（其他16语种）</td>
                  <td>应用级</td>
                  <td>750词/天</td>
                  <td>外译中（其他16语种）</td>
                  <td>应用级</td>
                  <td>100词/小时</td>
                </tr>
                <tr>
                  <td>中译外（其他16语种）</td>
                  <td>母语级</td>
                  <td>1000字/天</td>
                  <td>中译外（其他16语种）</td>
                  <td>母语级</td>
                  <td>130字/小时</td>
                </tr>
              </tbody>
            </table>
            <div class="trans-time-ill">
              <p>说明：</p>
              <p>1、译员工作时间：周一至周日9:00—24:00(重大节假日除外)</p>
              <p>2、返稿时间节点：每天12:00、15:00、18:00</p>
              <p>3、预估提交时间为：字数除以速度得出翻译用时，然后折合到译员工作时间，在最接近的返稿时间节点返回译文。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { API_1, Global } from '@/conf/api'
import tool from '../../tool/tool'
import login from '../../components/login.vue'
import multi from '../../components/header.vue'
export default {
  //import引入的组件需要注入到对象中才能使用
  name: 'order',
  components: { multi, login },
  data() {
    // 手机号验证
    var checkPhone = (rule, value, callback) => {
      const phoneReg = /^1[23456789]\d{9}$/
      if (!value) {
        return callback(new Error('电话号码不能为空'))
      }
      setTimeout(() => {
        if (!Number.isInteger(+value)) {
          callback(new Error('请输入数字值'))
        } else {
          if (phoneReg.test(value)) {
            callback()
          } else {
            callback(new Error('电话号码格式不正确'))
          }
        }
      }, 100)
    }
    //邮箱验证
    var checkEmail = (rule, value, callback) => {
      const reg =
        /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/
      // /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      if (!value) {
        return callback(new Error('邮箱不能为空'))
      }
      setTimeout(() => {
        if (reg.test(value)) {
          this.disabled = false
          callback()
        } else {
          callback(new Error('邮箱格式不正确'))
        }
      }, 100)
    }
    //这里存放数据
    return {
      word: false, // 价格文案中，字or词切换
      loginOn: false, //登录完成回
      uploadStatus: false, //上传按钮可用状态
      timeshow: false, //评估方案弹窗
      uid: '',
      token: '',
      fullscreenLoading: false, //loading状态
      header: { 'Content-Type': 'multipart/form-data' },
      fileList: [],
      submitShow: true,
      dialogFormVisible: false, //登录框显示or隐藏
      optionTemp: [], //切换语言的临时存储
      options1: [], //语言选项源
      options2: [], //语言选项目标
      radio: '2',
      checkedRule: true,
      priceSet: [],
      doc: false, //是否是从文档过来的
      upload: API_1 + Global.uploadhandler,
      fileUrl: '',
      receiveSms: 1, //是否接收短信订阅
      orderInfo: {
        source: '英语',
        target: '简体中文',
      },
      ruleForm: {
        languageSource: 22,
        languageTarget: 21,
        phone: '',
        email: '',
        content: '',
        remarks: null,
        checkedPhone: '',
        contentTxt: '',
        checkedPhone: true,
        contentFile: [],
      },
      bzjy: false,
      yyjy: false,
      zjjy: false,
      myjy: false,
      rules: {
        // contentTxt: [
        //   { required: true, message: '请输入翻译内容', trigger: 'blur' },
        // ],
        contentFile: [],
        phone: [
          {
            required: true,
            validator: checkPhone,
            trigger: 'blur',
          },
        ],
        email: [
          {
            required: true,
            validator: checkEmail,
            trigger: 'blur',
          },
        ],
      },
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    listen($event) {
      if (event.keyCode === 13) {
        event.preventDefault() // 阻止浏览器默认换行操作
        return false
      }
    },
    uploadSuccess(res, file, fileList) {
      let temp = []
      fileList.map((val) => {
        temp.push(val.response.data)
      })
      this.uploadStatus = true
      this.ruleForm.contentFile = fileList
      this.fileUrl = temp.toString()
    },
    removeFile(file, fileList) {
      this.uploadStatus = false
      this.ruleForm.contentFile = fileList
      this.fileUrl = ''
    },
    beforeUpload(file) {
      const fileSuffix = file.name.substring(file.name.lastIndexOf('.') + 1)

      const whiteList = ['rar', 'zip', 'doc', 'docx', 'pdf', 'jpg', 'txt']

      if (whiteList.indexOf(fileSuffix) === -1) {
        this.$message({
          showClose: true,
          message: '支持扩展名：txt、rar、zip、doc、docx、pdf、jpg的文件',
          type: 'warning',
        })
        return false
      }

      const isLt2M = file.size / 1024 / 1024 < 20
      if (!isLt2M) {
        this.$message({
          showClose: true,
          message: '上传文件大小不能超过 20MB',
          type: 'warning',
        })
        return false
      }
    },
    submitOrder() {
      if (this.uid) {
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            if (this.doc) {
              if (this.ruleForm.contentTxt == '') {
                this.$message({
                  showClose: true,
                  message: '翻译内容不能为空',
                  type: 'warning',
                })
              } else if (
                this.ruleForm.languageSource == '' ||
                this.ruleForm.languageTarget == ''
              ) {
                this.$message({
                  showClose: true,
                  message: '请正确选择翻译语言',
                  type: 'warning',
                })
              } else {
                let promise = new Promise((resolve, reject) => {
                  this.text(resolve)
                })
                promise.then((val) => {
                  this.fullscreenLoading = true
                  let params = this.$qs.stringify({
                    uid: this.uid,
                    code: this.token,
                    sourceLanguage: this.ruleForm.languageSource,
                    targetLanguage: this.ruleForm.languageTarget,
                    fileUrl: this.fileUrl,
                    comment: this.ruleForm.remarks, //备注
                    mobile: this.ruleForm.phone,
                    email: this.ruleForm.email,
                    standard: this.radio, //1\2\3\4
                    receiveSms: this.ruleForm.checkedPhone, //是否接收
                    upstatus: this.doc,
                  })
                  this.axios
                    .post(API_1 + Global.creatOrder, params, {
                      headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                      },
                    })
                    .then((res) => {
                      //成功 1 失败 0  手机号不支持 2
                      this.fullscreenLoading = false
                      if (res.data.status == 2) {
                        this.$message({
                          message: '您的手机号暂不支持下单',
                          type: 'warning',
                          offset: 100,
                        })
                      } else {
                        this.$router.push({
                          path: '/TranslateResult',
                          query: {
                            code: res.data.data,
                            status: res.data.status,
                          },
                        })
                      }
                    })
                    .catch((res) => {
                      this.$message({
                        message: '网络连接失败，请刷新重试',
                        type: 'error',
                        offset: 100,
                      })
                    })
                })
              }
            } else {
              if (this.ruleForm.contentFile.length == 0) {
                this.$message({
                  showClose: true,
                  message: '您还未上传翻译文件',
                  type: 'warning',
                })
              } else if (
                this.ruleForm.languageSource == '' ||
                this.ruleForm.languageTarget == ''
              ) {
                this.$message({
                  showClose: true,
                  message: '请正确选择翻译语言',
                  type: 'warning',
                })
              } else {
                this.fullscreenLoading = true
                let params = this.$qs.stringify({
                  uid: this.uid,
                  code: this.token,
                  sourceLanguage: this.ruleForm.languageSource,
                  targetLanguage: this.ruleForm.languageTarget,
                  fileUrl: this.fileUrl,
                  comment: this.ruleForm.remarks, //备注
                  mobile: this.ruleForm.phone,
                  email: this.ruleForm.email,
                  standard: this.radio, //1\2\3\4
                  receiveSms: this.ruleForm.checkedPhone, //是否接收
                  upstatus: this.doc,
                })
                this.axios
                  .post(API_1 + Global.creatOrder, params, {
                    headers: {
                      'Content-Type': 'application/x-www-form-urlencoded',
                    },
                  })
                  .then((res) => {
                    //成功 1 失败 0  手机号不支持 2
                    this.fullscreenLoading = false
                    if (res.data.status == 2) {
                      this.$message({
                        message: '您的手机号暂不支持下单',
                        type: 'warning',
                        offset: 100,
                      })
                    } else {
                      this.$router.push({
                        path: '/TranslateResult',
                        query: {
                          code: res.data.data,
                          status: res.data.status,
                        },
                      })
                    }
                  })
                  .catch((res) => {
                    this.$message({
                      message: '网络连接失败，请刷新重试',
                      type: 'error',
                      offset: 100,
                    })
                  })
              }
            }
          } else {
            return false
          }
        })
      } else {
        this.dialogFormVisible = true
      }
    },
    todoc() {
      this.doc = !this.doc
    },
    handleExceed() {},
    submit() {
      this.submitShow = false
    },
    result(val) {
      //location.reload()
      this.loginOn = true
      this.uid = tool.getCookie('user')
      this.token = tool.getCookie('qxchuhai')
    },
    exchange() {
      //交换语言
      let temp = this.ruleForm.languageSource
      this.ruleForm.languageSource = this.ruleForm.languageTarget
      this.ruleForm.languageTarget = temp
      let temp1 = this.orderInfo.source
      this.orderInfo.source = this.orderInfo.target
      this.orderInfo.target = temp1
      if (this.ruleForm.languageSource && this.ruleForm.languageTarget) {
        this.priceSetting()
        this.radio = '2'
      }
    },
    //选择源语言
    selectLanguageS(val) {
      if (val != 21) {
        this.ruleForm.languageTarget = 21
        this.radio = '2'
        this.priceSetting()
        let obj = {}
        obj = this.optionTemp.find((item) => {
          //遍历list的数据
          return item.ye_id === val //筛选出匹配数据
        })
        this.orderInfo.source = obj.ye_name
        this.orderInfo.target = '简体中文'
      } else {
        this.options2 = this.optionTemp
        if (val == this.ruleForm.languageTarget) {
          this.$message({
            message: '源语言与目标语言不能相同',
            type: 'warning',
            offset: 100,
          })
          this.ruleForm.languageSource = ''
        }
      }
    },
    //选择目标语言
    selectLanguageT(val) {
      if (val != 21) {
        this.ruleForm.languageSource = 21
        this.radio = '2'
        this.priceSetting()
        let obj = {}
        obj = this.optionTemp.find((item) => {
          //遍历list的数据
          return item.ye_id === val //筛选出匹配数据
        })
        this.orderInfo.target = obj.ye_name
        this.orderInfo.source = '简体中文'
      } else {
        this.options1 = this.optionTemp
        if (val == this.ruleForm.languageSource) {
          this.$message({
            message: '源语言与目标语言不能相同',
            type: 'warning',
            offset: 100,
          })
          this.ruleForm.languageTarget = ''
        }
      }
    },
    //语言接口
    languageData() {
      this.axios
        .get(API_1 + Global.language)
        .then((res) => {
          this.optionTemp = res.data.data
          this.options1 = res.data.data
          this.options2 = res.data.data
          // arr.splice(
          //   arr.findIndex((item) => item.id === data.id),
          //   1
          // )
        })
        .catch((res) => {
          console.log(res)
        })
    },
    priceSetting() {
      let source = this.ruleForm.languageSource
      let target = this.ruleForm.languageTarget
      if (source == 21 || source == 28 || source == 32) {
        this.word = true
      } else {
        this.word = false
      }
      let params = this.$qs.stringify({
        source: this.ruleForm.languageSource,
        target: this.ruleForm.languageTarget,
      })
      this.axios
        .post(API_1 + Global.priceSetting, params, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .then((res) => {
          if (res.data.status == 1) {
            this.priceSet = res.data.data
            if (this.priceSet.standard == 0) {
              this.bzjy = true
            } else {
              this.bzjy = false
            }
            if (this.priceSet.application == 0) {
              this.yyjy = true
            } else {
              this.yyjy = false
            }
            if (this.priceSet.native_language == 0) {
              this.myjy = true
            } else {
              this.myjy = false
            }
            if (this.priceSet.expert == 0) {
              this.zjjy = true
            } else {
              this.zjjy = false
            }
          } else {
            this.priceSet.standard = 0
            this.priceSet.application = 0
            this.priceSet.native_language = 0
            this.priceSet.expert = 0
            this.radio = ''
            this.bzjy = true
            this.yyjy = true
            this.myjy = true
            this.zjjy = true
            this.$message({
              message: '您所选择的语项暂不支持',
              type: 'warning',
              offset: 100,
            })
          }
        })
        .catch((res) => {
          this.$message({
            message: '网络连接失败，请刷新重试',
            type: 'error',
            offset: 100,
          })
        })
    },
    text(resolve) {
      let params = this.$qs.stringify({
        textcontent: this.ruleForm.contentTxt,
      })
      return this.axios
        .post(API_1 + Global.text, params, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .then((res) => {
          this.fileUrl = res.data.data
          resolve()
        })
        .catch((res) => {
          this.$message({
            message: '网络连接失败，请刷新重试',
            type: 'error',
            offset: 100,
          })
        })
    },
    // getInfo() {
    //   let params = {
    //     id: this.doc,
    //     uid: this.uid,
    //   }
    //   this.axios
    //     .get(API_1 + Global.detail, { params: params })
    //     .then((res) => {
    //       this.ruleForm.contentTxt = res.data.data[2].otherlanguage
    //       // this.ruleForm.contentTxt = this.ruleForm.contentTxt.replace(
    //       //   /<[^>]+>/g,
    //       //   ''
    //       // )
    //     })
    //     .catch((res) => {
    //       console.log(res)
    //     })
    // },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.uid = tool.getCookie('user')
    this.token = tool.getCookie('qxchuhai')
    if (this.$route.query.doc) {
      this.doc = true
    }
    //this.doc = this.$route.query.doc
    // if (this.doc) {
    //   this.getInfo()
    // }
    this.languageData()
    this.priceSetting()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style>
</style>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.submitActive {
  cursor: not-allowed !important;
  background: #f4f4f4 !important;
  color: #666 !important;
}
#overlay-bg {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 20;
  background-color: rgba(0, 0, 0, 0.5);
  text-align: center;
  white-space: nowrap;

  .overlay-box-common {
    display: inline-block;
    vertical-align: middle;
    text-align: left;
    white-space: normal;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    background-color: #fff;
    overflow-y: scroll;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    #message-area {
      padding: 0 22px;
      border: 1px solid #d6e1ed;
      -webkit-border-radius: 0 0 5px 5px;
      -moz-border-radius: 0 0 5px 5px;
      border-radius: 0 0 5px 5px;
      border-bottom: 0;
      .trans-time-container {
        .trans-time-table {
          border-collapse: collapse;
          margin-top: 14px;
          width: 100%;
          /deep/td,
          th {
            border: 1px solid #e6e6e6;
            line-height: 38px;
            text-align: center;
          }
          /deep/th {
            background-color: #f5f5f5;
          }
          /deep/td:first-child,
          th:first-child {
            width: 178px;
          }
        }
      }
    }
    header {
      -webkit-border-radius: 5px 5px 0 0;
      -moz-border-radius: 5px 5px 0 0;
      border-radius: 5px 5px 0 0;
      height: 41px;
      font-size: 14px;
      line-height: 40px;
      color: #667283;
      background-color: #f2faff;
      padding: 0 22px;
      a {
        float: right;
      }
    }
  }
}

.rule {
  color: #0f4d72;
  text-decoration: underline;
}
.explain {
  li {
    img {
      margin-right: 5px;
    }
  }
}
.exchange {
  background: url('../../assets/exchange.png') no-repeat center center;
  background-size: 18px 18px;
  width: 18px;
  height: 18px;
  display: inline-block;
  vertical-align: middle;
  margin: 0px 10px;
}
.upload-demo {
  display: inline-block;
}
.remarks {
  font-size: 13px;
  color: #999;
  // margin-left: 100px;
  text-align: left;
  margin-bottom: 10px;
}

.el-select-dropdown__item.selected {
  color: #0f4d72;
}
.el-radio.is-bordered.is-checked {
  border-color: #0f4d72;
  vertical-align: bottom;
}
.el-radio.is-bordered + .el-radio.is-bordered {
  vertical-align: bottom;
}
.el-textarea {
  /deep/.el-textarea__inner:focus {
    border-color: #0f4d72;
  }
}
.el-button--primary {
  border-color: #0f4d72;
}
/deep/.el-upload-list__item-name {
  width: 300px;
}
.el-checkbox {
  display: block;
  width: 120px;

  /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
    color: #0f4d72;
  }
  /deep/.el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #0f4d72;
  }
  /deep/.el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #0f4d72;
    border-color: #0f4d72;
  }
  /deep/.el-checkbox__inner:hover {
    border-color: #0f4d72;
  }
}
.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: not-allowed;
  background: white;
  opacity: 0.6;
  z-index: 3;
}
.el-radio {
  color: #606266;
  cursor: pointer;
  margin-right: -3px;
  width: 200px !important;
  height: 313px !important;
  text-align: center !important;
  padding-top: 29px;
  .jg {
    color: #999;
    font-size: 16px;
    margin-top: 20px;
    span {
      font-size: 36px;
      color: #0f4d72;
    }
  }
  .no {
    color: #999;
    font-size: 22px;
    margin-top: 35px;
  }

  ul {
    padding: 0 15px;
    li {
      color: #666;
      font-size: 12px;
      text-align: left;
      margin-bottom: 16px;
      width: 160px;
      white-space: pre-wrap;
    }
  }
  .txt {
    font-size: 12px;
    color: #666;
    width: 145px;
    white-space: pre-wrap;
    margin: 14px auto 0;
    line-height: 20px;
  }
  /deep/.el-radio__input.is-checked .el-radio__inner {
    border-color: #0f4d72;
    background: #0f4d72;
    width: 18px;
    height: 18px;
  }
  /deep/.el-radio__inner {
    width: 18px;
    height: 18px;
  }
  /deep/.el-radio__inner::after {
    width: 8px;
    height: 8px;
  }
  /deep/.el-radio__label {
    color: #0f4d72;
    font-size: 18px;
  }
}
.order {
  background: url('../../assets/listbg.jpg') repeat-y center center;
  padding-top: 20px;
  .main {
    width: 1200px;
    min-width: 1200px;
    margin: 0px auto;
    .content {
      width: 1000px;
      margin: 0 auto;
      padding: 40px 0 0 0;
      button {
        width: 150px;
        height: 40px;
        background: #0f4d72;
        border-radius: 5px;
        color: #fff;
        cursor: pointer;
        font-size: 14px;
        // margin-top: 25px;
      }
      .confirmInfo {
        padding: 40px;
        text-align: left;
        margin: 20px auto 0;
        background: #fff;
        color: #666;
        .submit {
          width: 150px;
          height: 40px;
          background: #0f4d72;
          border-radius: 5px;
          color: #fff;
          cursor: pointer;
          margin-top: 25px;
        }

        h4 {
          color: #666;
        }
        .info {
          font-size: 14px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          span {
            text-align: left;
            display: inline-block;
          }
          ul {
            height: 40px;
            background: #f7f9fb;
            border: 1px solid #dcdcdc;
            border-radius: 5px;
            display: inline-block;
            line-height: 40px;
            width: 845px;
            li {
              display: inline-block;
              color: #999999;
              margin: 0 20px;
              span {
                color: #333;
              }
            }
          }
        }
      }
      .el-form {
        background: #fff;
        padding: 40px;
        .el-form-item {
          text-align: left;

          /deep/.el-form-item__label {
            font-size: 14px;
            color: #666;
            width: 80px !important;
          }
          /deep/.el-form-item__content {
            .todoc {
              position: absolute;
              left: 150px;
              top: 0px;
            }
          }
        }
        /deep/.el-select {
          .el-input__inner:focus {
            border-color: #0f4d72;
          }
          .el-input.is-focus {
            &:focus {
              border-color: #0f4d72;
            }
            .el-input__inner {
              border-color: #0f4d72;
            }
          }
        }
      }
    }
    .submitbox {
      width: 1000px;
      margin: 0 auto;
      padding: 40px 0 0 0;
    }
  }
}
</style>